import { ModuleBase, Stack, Link, Box, ResponsiveImage } from '@/components';
import { SideBySideModuleCard, SideBySideModuleModel } from './SideBySideModule';
import { EqualHeight, EqualHeightElement } from 'react-equal-height';

const MembershipTrendsIntelligence = (data: SideBySideModuleModel) => {
  const {
    props: { title, link1, cards },
  } = data;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: '#F9F2E1' } }}
      noPadding
      className="MembershipTrendsIntelligence py-10 lg:py-18"
    >
      <Stack className="container flex flex-col">
        {title && (
          <Box
            className="text-style-h2 !text-[38px] leading-[40px] text-[#1B3E4E] sm:!text-[50px] sm:leading-[52px] md:!text-[60px] md:leading-[60px] lg:!text-[75px] lg:leading-[75px]"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}
        <EqualHeight>
          <div className="mt-10 grid w-full grid-cols-1 gap-4 md:grid-cols-2 lg:mt-[86px] lg:grid-cols-4 xl:gap-6">
            {cards && cards.map((card, index) => <TrendIntelligenceCard key={index} {...card} />)}
          </div>
        </EqualHeight>
        {link1 && (
          <div className="mt-10 flex w-full lg:mt-20">
            <Link
              animate
              className="btn primary v2 text-center !text-[#F9F2E1] hover:!text-black md:text-left"
              link={link1}
            />
          </div>
        )}
      </Stack>
    </ModuleBase>
  );
};

export default MembershipTrendsIntelligence;

const TrendIntelligenceCard = ({ title, text, image }: SideBySideModuleCard) => {
  return (
    <Box className="flex flex-col bg-[#1B3E4E]">
      <div className="aspect-[16/9] w-full">
        {image && (
          <ResponsiveImage
            image={image}
            widths={{ xs: 330, sm: 330, md: 330, lg: 330, xl: 330, xxl: 440 }}
            heights={{ xs: 186, sm: 186, md: 186, lg: 186, xl: 186, xxl: 250 }}
          />
        )}
      </div>
      <div className="xxl:pb-24 flex flex-col gap-4 p-5 pb-10 lg:p-5 lg:pb-10 xl:p-6 xl:pb-20">
        <EqualHeightElement name="title" className="overflow-visible">
          <div className="text-style-h4 text-[24px] leading-[28px] text-white sm:text-[25px] sm:leading-[28px] lg:text-[30px] lg:leading-[30px] xl:text-[32px] xl:leading-[35px]">
            {title}
          </div>
        </EqualHeightElement>
        {text && (
          <div
            className="text-style-body text-[16px] leading-[18px] text-white md:text-[18px] md:leading-[20px]"
            dangerouslySetInnerHTML={{ __html: text }}
          />
        )}
      </div>
    </Box>
  );
};
